import React, { useRef, useEffect } from 'react';
import { FileTab } from '@/types';

interface ContextMenuMobileProps {
  tab: FileTab;
  onClose: () => void;
  onCloseTab: () => void;
  onPin: () => void;
}

export const ContextMenu: React.FC<ContextMenuMobileProps> = ({
  tab,
  onClose,
  onCloseTab,
  onPin,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Slide up animation
    if (menuRef.current) {
      menuRef.current.animate([
        { transform: 'translateY(100%)' },
        { transform: 'translateY(0)' },
      ], {
        duration: 150,
        easing: 'ease-out',
      });
    }
  }, []);

  return (
    <div className="context-menu-mobile-overlay" onClick={onClose}>
      <div className="context-menu-mobile" ref={menuRef} onClick={e => e.stopPropagation()}>
        <div className="context-menu-mobile-header">
          <span className="context-menu-mobile-title">{tab.name}</span>
          <button className="context-menu-mobile-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="context-menu-mobile-content">
          <button className="context-menu-mobile-item destructive" onClick={onCloseTab}>
            Close
          </button>
          <div className="context-menu-mobile-separator" />
          <button className="context-menu-mobile-item" onClick={onPin}>
            {tab.isPinned ? 'Unpin' : 'Pin'}
          </button>
        </div>
      </div>
    </div>
  );
};